/**
 * Chatbot API Service
 * Integración con el backend del chatbot
 */

import { privateApi } from '@/config/axios.config';
import {
  ChatbotResponse,
  SendMessagePayload,
  Conversation,
  ConversationHistoryResponse,
  RenameConversationPayload,
} from '../types';

const API_BASE_URL = '/chatbot';

/**
 * Send a message to the chatbot
 */
export const sendMessage = async (
  payload: SendMessagePayload
): Promise<ChatbotResponse & { metadata?: any }> => {
  const response = await privateApi.post<{ success: boolean; data: ChatbotResponse & { metadata?: any } }>(
    `${API_BASE_URL}/message`,
    payload
  );
  return response.data.data;
};

/**
 * Get conversation history (messages)
 */
export const getConversationHistory = async (
  conversationId: string
): Promise<any[]> => {
  const response = await privateApi.get<{ success: boolean; data: any[] }>(
    `${API_BASE_URL}/conversation/${conversationId}/history`
  );
  return response.data.data;
};

/**
 * Get list of conversations
 */
export const getConversations = async (
  page: number = 1,
  limit: number = 10,
  search?: string
): Promise<ConversationHistoryResponse> => {
  const response = await privateApi.get<{ success: boolean; data: ConversationHistoryResponse }>(
    `${API_BASE_URL}/conversations`,
    {
      params: { page, limit, search },
    }
  );
  return response.data.data;
};

/**
 * Create a new conversation
 */
export const createConversation = async (): Promise<Conversation> => {
  const response = await privateApi.post<{ success: boolean; data: Conversation }>(
    `${API_BASE_URL}/conversation`,
    {}
  );
  return response.data.data;
};

/**
 * Rename a conversation
 */
export const renameConversation = async (
  payload: RenameConversationPayload
): Promise<void> => {
  await privateApi.put(
    `${API_BASE_URL}/conversation/${payload.conversationId}/rename`,
    { title: payload.newTitle }
  );
};

/**
 * Delete a conversation
 */
export const deleteConversation = async (
  conversationId: string
): Promise<void> => {
  await privateApi.delete(`${API_BASE_URL}/conversation/${conversationId}`);
};

export const chatbotApi = {
  sendMessage,
  getConversationHistory,
  getConversations,
  createConversation,
  renameConversation,
  deleteConversation,
};

